export default {
'_.lang.pl.text': 'polski',
'_.lang.en.text': 'english',
'_.lang.de.text': 'deutsch',
'_.lang.es.text': 'español',
'_.lang.it.text': 'italiano',
'_.lang.nl.text': 'nederlands',
'_.lang.ru.text': 'русский',
'_.lang.sk.text': 'slovenský',
'_.lang.cs.text': 'čeština',
'_.lang.uk.text': 'український',
'_.lang.ro.text': 'română',
'_.lang.fr.text': 'français',
'_.lang.hu.text': 'magyar',
'_.socialPoints': 'SocialPoints',
'_.cashPoints': 'CashPoints',
'_.pln': 'PLN',
'_.and': 'a',
'_.loadingSpinnerText': 'Počkajte prosím...',
'pageTimerMax.text': 'Po uplynutí času budete automaticky presmerovaní na ďalšiu stránku.',
'pageTimerMax.timeLeft': 'Zostávajúci čas',
'pageTimerMin.text': 'Pred uplynutím času nie je možné prejsť ďalej.',
'pageTimerMin.timeLeft': 'Zostávajúci čas',
'pageTimerMin.allowNext': 'Môžete pokračovať ďalej',
'survey.registerForm.label.email': 'E-mail',
'survey.registerForm.label.newsletter': 'Chcem dostávať informačný bulletin',
'survey.registerForm.label.regulations': 'Súhlasím so zásadami ochrany osobných údajov a zmluvnými podmienkami',
'survey.registerForm.button.register': 'Registrácia',
'survey.registerForm.registered': 'Ďakujeme za registráciu. Do vašej e-mailovej schránky bol odoslaný e-mail s aktivačným odkazom.',
'survey.registerForm.cardHeader': 'Zaregistrujte sa a získavajte body!',
'survey.registerForm.cardBody': 'Za vyplnenie prieskumu ste získali',
'survey.registerForm.cardBody2': 'Body vám budú pripísané po zaregistrovaní účtu na stránke swpanel.co.uk. Zadajte svoju e-mailovú adresu a zaregistrujte si účet na stránke swpanel.pl',
'survey.notProperDevice': 'Žiaľ, tento prieskum nemôžete dokončiť na tomto zariadení.',
'survey.properDevices': 'K prieskumu môžete pristupovať z nasledujúcich zariadení:',
'survey.device-phone': 'smartfón',
'survey.device-tablet': 'tablet',
'survey.device-desktop': 'počítač/notebook',
'nextSurveys.header.seeAlso': 'Pozrite si aj ďalšie prieskumy',
'nextSurveys.button.fill': 'Vyplňte',
'question.noContent': 'Chýba obsah otázky',
'question.input.placeholder.typeYourAnswer': 'Zadajte svoju odpoveď',

'question.conjoint.go': 'Kliknite na tlačidlo "Ďalej"',
'question.matrix.carousel.go': 'Kliknite na tlačidlo "Ďalej"',
'question.carousel.prevBtn': 'Predchádzajúci výrok',
'question.carousel.nextBtn': 'Ďalší výrok',

'question.open.email.inputPlaceholder': 'Zadajte e-mailovú adresu',
'question.open.email.emailVerify.sendCode': 'Odoslať overovací kód',
'question.open.email.emailVerify.enderCode': 'Zadajte prijatý kód',
'question.open.email.emailVerify.enderCode.inputPlaceholder': 'Zadajte kód',
'question.open.email.emailVerify.confirm': 'Potvrďte',
'question.open.email.emailVerify.codeIncorrect': 'Zadaný kód je nesprávny',
'question.open.email.emailVerify.codeCorrect': 'E-mailová adresa je správne overená',
'question.open.email.rodoText': 'The administrator of your personal data is SW Research Sp. z o.o. located at ul. J. Dąbrowskiego 64a, 02-561 Warszawa, Warsaw. For matters related to protecting your personal data and exercising your rights, you can contact the Data Protection Inspector at iod@swresearch.pl. Your personal data will be processed during the survey and accounting documentation for 5 years after the year the survey was completed. Your personal data will be processed for the purpose of participating in opinion surveys, analytical purposes to match our services to the needs of our clients, and for keeping accounting documentation (Article 6 (1) (b) of the GDPR(RODO), Article 6 (1) (f) of the GDPR(RODO), Article 6 (1) (c) of the GDPR(RODO) in connection with Article 86 § 1 of the Tax Ordinance).',

'footer.pauseButton.text': 'Pozastavenie plnenia',
'footer.buttonPrev.text': 'Späť',
'footer.buttonClear.text': 'Vymazať',
'footer.buttonNext.text': 'Ďalej',
'footer.buttonEnd.text': 'Dokončiť',
'footer.buttonStart.text': 'Spustiť prieskum',
'question.matrix.nextStatement': 'Next statement',
'question.matrix.previousStatement': 'Previous statement',
};
